"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderModifyHistoryApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var orderModifyHistoryApi = exports.orderModifyHistoryApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/orderModifyHistory",
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: "/orderModifyHistory",
      data: data,
      method: 'post'
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/orderModifyHistory/".concat(id),
      method: 'patch',
      data: data
    });
  },
  delete: function _delete(id) {
    return (0, _request.default)({
      url: "/orderModifyHistory/".concat(id),
      method: 'delete'
    });
  }
};